import { useContext } from "react"
import AuthContext from "./AuthContext"
import { extendAuthContext } from "../../types/user/AuthContextData"

export type ExtendedAuthContextData = ReturnType<typeof extendAuthContext>

const useAuthContext = (): ExtendedAuthContextData => {
  const user = useContext(AuthContext)

  if (user === undefined) {
    throw new Error("Access denied")
  }
  return extendAuthContext(user)
}

export default useAuthContext
